import config from "@/config"
import http from "@/utils/request"

export function getData(data) {
	return http.get(`${config.API_URL}/get/website/getWebsiteData`, data);
}


export function getJobVacancy(data) {
	return http.get(`${config.API_URL}/get/website/getJobVacancy`, data);
}


export function getStaffStories(data) {
	return http.get(`${config.API_URL}/get/website/getStaffStories`, data);
}

export function getProduct(data) {
	return http.get(`${config.API_URL}/get/website/getProduct`, data);
}

export function getCampus(data) {
	return http.get(`${config.API_URL}/get/website/getCampus`, data);
}


export function getYoung(data) {
	return http.get(`${config.API_URL}/get/website/getYoung`, data);
}

export function getAbout(data) {
	return http.get(`${config.API_URL}/get/website/getAbout`, data);
}
export function getJobDetail(data) {
	return http.get(`${config.API_URL}/get/website/getJobDetail`, data);
}

export function getNavbar(data) {
	return http.get(`${config.API_URL}/get/website/getNavbar`, data);
}


export function getDicList(data) {
	return http.get(`${config.API_URL}/get/website/getDicList`, data);
}

export default { getData,getJobVacancy,getStaffStories,getProduct,getCampus,getYoung,getAbout,getJobDetail,getNavbar,getDicList}
